import * as api from '@/utils/request.js'
// import axios from 'axios'
// import request from '@/utils/request'

// 专家列表
export function getExportList(params) {
  return api.get(`http://i.didaward.cn/prod-api/business/expert/listall`, params)
}

// 新闻列表
export function getNewsList(params) {
  // return api.get(`http://localhost:8083/business/news/listall`, params)
  return api.get(`http://xxx.xulumaterial.com/prod-api/business/news/listall`, params)
}

// 产品列表
export function getProductListAll(params) {
  return api.get(`http://120.77.38.141:8083/business/product/productListAll`, params)
}

// 新闻详情
export function getNewsListDetails({
  newsId
}) {
  return api.get(`http://i.didaward.cn/prod-api/business/news/detail/${newsId}`)
}

// 获取作品列表;
export function getWorkList(data) {
  return api.get(`http://i.didaward.cn/prod-api/business/expert/listall`, data)
}

// 根据年份获取作品列表;
export function getWorkYearList(params) {
  return api.get(`http://i.didaward.cn/prod-api/business/work/listall`, params)
}


// 根据年份获取作品列表;
export function getDynamicList(params) {
  // return api.post(`http://localhost:8084/business/dynamic/list`, params)
  return api.post(`http://120.77.38.141:8084/business/dynamic/list`, params)
}

// 获取动态详情
export function getDynamicDetail(id) {
  return api.get(`/business/dynamic/detail/${id}`);
}

// 获取案例列表
export function getCaseList() {
  return api.post(`/business/case/list`, {});
}




// WEBPACK FOOTER //
// ./src/api/api.js